import { INotification } from './notification.interface'

export class Notification {
  id: string
  title: string
  description: string
  time: string
  see: boolean
  constructor(from: INotification) {
    this.id = from.id
    this.title = from.title
    this.description = from.description
    this.time = from.time
    this.see = from.see
  }
}
